export default (values) => {

  const errors = {};

  if (!values.content) errors.content = true;

  return errors;
  
}